import React, {
  createRef,
  useContext,
  useEffect,
  useRef,
  type RefObject,
} from 'react';
import { type RestModalForwards } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import {
  FunnelButton,
  FunnelButtonIcon,
  getSvgIcon,
} from '@bbkFunnelComponents/v2';
import { RefsContext } from '@bbkFunnelUtils/refs.context';

export const MultiCTAOtherActions: ReactFCC<{
  id: string;
  actions: RestModalForwards[];
  handleAction: (action: RestModalForwards) => void;
}> = ({ id, actions, handleAction }) => {
  const refsPrefix = id;
  const refsCtx = useContext(RefsContext);

  const btnRefs = useRef<RefObject<HTMLButtonElement>[]>([]);
  useEffect(() => {
    btnRefs.current.forEach((btn, idx) =>
      refsCtx?.addRef(`${refsPrefix}-btn${idx}`, btn)
    );
  }, [btnRefs?.current.length]);
  useEffect(() => {
    btnRefs.current = actions.map(
      (x, i) => btnRefs.current[i] ?? createRef<HTMLButtonElement>()
    );
  }, [actions.length]);
  return (
    <>
      {actions.map((ga, idx) => (
        <FunnelButton
          key={idx}
          onClick={() => handleAction(ga)}
          classes="d-flex align-items-center justify-content-center"
          ref={btnRefs.current[idx]}
        >
          {ga.icon ? (
            <FunnelButtonIcon>
              {getSvgIcon(ga.icon.toLowerCase())}
            </FunnelButtonIcon>
          ) : null}
          {ga.text}
        </FunnelButton>
      ))}
    </>
  );
};
